import { apiRequest } from "../api/client";

export interface Campus {
  id: number;
  name: string;
  code: string;
  city?: string;
  state?: string;
  country?: string;
  is_main: boolean;
  established_year?: number;
}

export interface OrganizationUnit {
  id: number;
  name: string;
  code: string;
  unit_type: string;
  campus_name?: string;
  parent_name?: string;
  head_user_email?: string;
  is_active: boolean;
}

export interface ExtendedUserProfile {
  id: number;
  phone?: string;
  alt_email?: string;
  timezone?: string;
  language?: string;
  bio?: string;
}

export const userManagementApi = {
  getOverview: async () => {
    return apiRequest<any>("/user-management/console/overview/");
  },
  getHierarchy: async () => {
    return apiRequest<any[]>("/user-management/console/hierarchy/");
  },
  getDirectory: async (role?: string, search?: string) => {
    let url = "/user-management/console/directory/";
    const params: string[] = [];
    if (role) params.push(`role=${encodeURIComponent(role)}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (params.length) url += `?${params.join("&")}`;
    return apiRequest<any[]>(url);
  },
  getCampuses: async (): Promise<Campus[]> => {
    return apiRequest<Campus[]>("/user-management/campuses/");
  },
  createCampus: async (data: Partial<Campus>): Promise<Campus> => {
    return apiRequest<Campus>("/user-management/campuses/", "POST", data);
  },
  getOrgUnits: async (): Promise<OrganizationUnit[]> => {
    return apiRequest<OrganizationUnit[]>("/user-management/org-units/");
  },
  createOrgUnit: async (data: Partial<OrganizationUnit>): Promise<OrganizationUnit> => {
    return apiRequest<OrganizationUnit>("/user-management/org-units/", "POST", data);
  },
  bulkImportUsers: async (records: any[]) => {
    return apiRequest<any>("/user-management/console/bulk_import/", "POST", { records });
  },
  transitionLifecycle: async (userId: number, eventType: string, notes: string = "") => {
    return apiRequest<any>("/user-management/console/transition_lifecycle/", "POST", {
      user_id: userId,
      event_type: eventType,
      notes,
    });
  },
};

export default userManagementApi;
